export enum TransactionEntityTypes {
  CONTRACT = "contract",
  VEHICLE = "vehicle",
}

export enum PaymentEntityTypes {
  CONTRACT = "contract",
  VEHICLE = "vehicles",
}
